import { Box, styled, Typography } from '@mui/material';

import HemeraBgLoginPage from '../../../assets/img/HEMERA_bg-login.webp';
import HemeraBgLPage from '../../../assets/img/HEMERA_bg-lpage.webp';

export const BoxBackgroundImageStyled = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isFormPage' &&
    prop !== 'isLoginPage' &&
    prop !== 'isOnboardingAdvancedSteps',
})(({ theme, isFormPage, isLoginPage, isOnboardingAdvancedSteps }) => ({
  backgroundImage: `url(${isLoginPage ? HemeraBgLoginPage : HemeraBgLPage})`,
  backgroundPosition: 'center',
  width: isFormPage ? '50%' : '100%',
  height: isFormPage ? '100%' : 'fill-available',
  minHeight: isFormPage ? 'auto' : '650px',
  backgroundSize: 'cover',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',

  [theme.breakpoints.up('xxl')]: {
    width: isOnboardingAdvancedSteps && '532px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    width: isOnboardingAdvancedSteps && '640px',
  },
}));

export const BackgroundMobileImageStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  width: '100%',
  height: isFormPage ? '216px' : 'fill-available',
  minHeight: '216px',
  objectFit: 'cover',

  [theme.breakpoints.up('md')]: {
    height: isFormPage && '416px',
    minHeight: '416px',
  },
}));

export const TextContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  display: isFormPage ? 'none' : 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '328px',
  margin: '0 auto',
  padding: '16px 0',

  [theme.breakpoints.up('sm')]: {
    width: '417px',
  },
  [theme.breakpoints.up('md')]: {
    width: '550px',
  },
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    width: isFormPage ? '448px' : '896px',
    margin: isFormPage ? '0 0 124px' : '0 0 48px',
  },
  [theme.breakpoints.up('xxl')]: {
    width: isFormPage ? '656px' : '1184px',
    margin: !isFormPage && '0 0 89px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    width: !isFormPage && '1408px',
    margin: !isFormPage && '0 0 48px',
  },
}));

export const LandingPageTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  fontFamily: 'Crimson Text',
  color: theme.palette.colors.onHomePageBackground,
  fontSize: '34px',
  fontWeight: 400,
  lineHeight: 1.18,
  letterSpacing: 'normal',

  [theme.breakpoints.up('lg')]: {
    maxWidth: !isFormPage && '650px',
    color: theme.palette.colors.onImageBackground,
    fontSize: '40px',
    lineHeight: 1.15,
  },
  [theme.breakpoints.up('xxl')]: {
    maxWidth: !isFormPage && '626px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    maxWidth: !isFormPage && '967px',
  },
}));

export const LandingPageSubTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onHomePageBackground,

  [theme.breakpoints.up('lg')]: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.colors.onImageBackground,
    maxWidth: !isFormPage && '650px',
  },
  [theme.breakpoints.up('xxl')]: {
    maxWidth: !isFormPage && '626px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    maxWidth: !isFormPage && '967px',
  },
}));

export const CardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  backgroundColor: theme.palette.colors.homePageBackground,
  width: '100%',
  height: !isFormPage && 'fill-available',
  display: 'flex',
  flexDirection: 'column',
}));
